import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import {
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    GroupeBouton,
    Bouton,
} from '@design-system-etat/dsfr-react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import {
    API_MODIFIER_ARME_EN_ERREUR,
    CONTEXT_MODIFIER_ARME_EN_ERREUR,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import RoutesRatelier from '../../../../../ratelier/routes';
import { getDateFRFromYYYYMMDDHHMMSS } from '../../../../../../../components/Commun/Form/Date/dateTranformation';
import { getPath } from '../../../../../../../utils/router';

const InformationsIncorrectesEtape3 = ({
    etapePrecedente,
    tableauConfigHeader,
    signalerArmeData,
}) => {
    const dispatch = useDispatch();

    const { data: armeAModifier } = useSelector((state) => state.armes.signalerErreur.recuperer);
    const { data: gdr } = useSelector((state) => state.armes.recupererGdrParNumeroRga);
    const {
        isLoading: isLoadingArmeEnregistree,
        erreur: erreurArmeEnregistree,
        data: numeroEncodageArmeEnregistree,
        message: messageArmeEnregistree,
        codeStatut: statutReponseArmeModifier,
    } = useSelector((state) => state.armes.signalerErreur.modifier);
    const { data: referentielElementArme } = useSelector((state) => state.referentiel.elementsArme);

    const { handleSubmit } = useForm({
        mode: 'onChange',
    });
    const history = useHistory();

    const [loadingArmeModifieePreview, setLoadingArmeModifieePreview] = useState(false);
    const [armeModifieePreview, setArmeModifieePreview] = useState([]);
    const [ouvrirModaleValidation, setOuvrirModaleValidation] = useState(false);
    const [ouvrirModaleErreur, setOuvrirModaleErreur] = useState(false);

    useEffect(() => {
        if (armeAModifier !== null && Array.isArray(Object.values(armeAModifier))) {
            setLoadingArmeModifieePreview(true);
            let liste = [null];
            let listeRga = [];
            liste.push(signalerArmeData.nouveauNumeroSerie ?? armeAModifier.numeroCarcasse);

            if (signalerArmeData.nouveauNumeroRga) {
                const { type, marque, modele, canonUn, canonDeux, classementFrancais } = gdr;
                listeRga = [
                    type,
                    marque,
                    modele,
                    canonUn ? canonUn.libelleCalibre : null,
                    canonDeux ? canonDeux.libelleCalibre : null,
                    classementFrancais,
                ];
            } else {
                const { type, marque, modele, canonUn, canonDeux, classement } = armeAModifier;
                listeRga = [type, marque, modele, canonUn, canonDeux, classement];
            }

            liste = liste.concat(listeRga);
            setArmeModifieePreview(liste);
            setLoadingArmeModifieePreview(false);
        }
    }, []);

    useEffect(() => {
        if (erreurArmeEnregistree) {
            setOuvrirModaleErreur(true);
        }
        if (!erreurArmeEnregistree && statutReponseArmeModifier === 200) {
            setOuvrirModaleValidation(true);
        }
    }, [erreurArmeEnregistree, statutReponseArmeModifier]);

    const retourRatelier = () => {
        dispatch(reinitialiseAPI(CONTEXT_MODIFIER_ARME_EN_ERREUR));
        setOuvrirModaleValidation(false);
        setOuvrirModaleErreur(false);
        history.push(getPath(RoutesRatelier));
    };

    const fermerModaleErreur = () => {
        setOuvrirModaleErreur(false);
    };

    const onSubmit = () => {
        const listeElementArme = [];
        const { typeElementArmeReferentielArme } = referentielElementArme;

        if (typeElementArmeReferentielArme) {
            typeElementArmeReferentielArme.forEach((element) => {
                const elementInitiale = armeAModifier.elementsArme?.find(
                    (el) => el.elementArmeReferentiel.id === element.id,
                );

                const numeroSerieModifie = signalerArmeData[`elementArme-${element.id}`];
                const numeroSerieInitiale = elementInitiale ? elementInitiale.numSerie : null;

                if (numeroSerieInitiale !== numeroSerieModifie) {
                    listeElementArme.push({
                        idElementArme: elementInitiale?.id,
                        idReferentiel: element.id,
                        numeroSerie: numeroSerieModifie,
                    });
                }
            });
        }
        const {
            uuidArme,
            nouveauNumeroRga,
            nouveauNumeroSerie,
            isNeutralisee,
            dateNeutralisationArme,
            lieuNeutralisationArme,
            noNumeroSerie,
        } = signalerArmeData;

        const modifierArmeEnErreurControllerInput = {
            uuidArme,
            ...(nouveauNumeroRga !== armeAModifier.gdrRga.numeroRGA && { nouveauNumeroRga }),
            ...(nouveauNumeroSerie !== armeAModifier.numeroCarcasse &&
                noNumeroSerie === false && { nouveauNumeroSerie }),
            ...(noNumeroSerie === true && { noNumeroSerie }),
            ...(listeElementArme.length >= 1 && { listeElementArme }),
            ...(isNeutralisee !== armeAModifier.neutralisee && { isNeutralisee }),
            ...(dateNeutralisationArme !==
                getDateFRFromYYYYMMDDHHMMSS(armeAModifier.dateNeutralisation) && {
                dateNeutralisationArme,
            }),
            ...(lieuNeutralisationArme !== armeAModifier.lieuNeutralisation && {
                lieuNeutralisationArme,
            }),
        };

        dispatch(
            postAPI(
                usagerClientReducer,
                API_MODIFIER_ARME_EN_ERREUR,
                modifierArmeEnErreurControllerInput,
                CONTEXT_MODIFIER_ARME_EN_ERREUR,
            ),
        );
    };

    return (
        <>
            {ouvrirModaleValidation && (
                <Modale id="modificationNumEncodage" taille="lg" closeCallback={retourRatelier}>
                    <ModaleTitre idModale="modificationNumEncodageModaleTitle">
                        Modification du numéro d'encodage
                    </ModaleTitre>
                    <ModaleContent>
                        <div style={{ padding: '1rem 0' }}>
                            Le nouveau numéro d&apos;encodage de l&apos;arme est :{' '}
                            <b>{numeroEncodageArmeEnregistree}</b>
                        </div>
                    </ModaleContent>
                    <ModaleFooter>
                        <GroupeBouton alignementHorizontal="right" isHorizontal>
                            <Bouton
                                label="Retour au râtelier numérique"
                                niveau="primaire"
                                onClick={retourRatelier}
                            />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}
            {ouvrirModaleErreur && (
                <Modale id="erreurModale" taille="lg" closeCallback={fermerModaleErreur}>
                    <ModaleTitre idModale="erreurModaleTitle">Erreur</ModaleTitre>
                    <ModaleContent>
                        <div style={{ padding: '1rem 0' }}>
                            Une erreur est survenue lors de l&apos;enregistrement :{' '}
                            <b>{messageArmeEnregistree}</b>
                        </div>
                    </ModaleContent>
                    <ModaleFooter>
                        <GroupeBouton alignementHorizontal="right" isHorizontal>
                            <Bouton label="Fermer" onClick={fermerModaleErreur} />
                            <Bouton
                                label="Retour au râtelier numérique"
                                niveau="primaire"
                                onClick={retourRatelier}
                            />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}
            <h2 className="fr-col-12 ">Nouvelles informations de l&apos;arme</h2>
            <SimpleTable
                entete={tableauConfigHeader}
                donnees={[armeModifieePreview]}
                isLoading={loadingArmeModifieePreview}
            />
            {gdr && gdr.classementFrancais !== armeAModifier.classement && (
                <strong>
                    <b>Le classement de l&apos;arme a été modifié.</b>
                </strong>
            )}
            <form onSubmit={handleSubmit(onSubmit)}>
                <BoutonEtape
                    isLoading={isLoadingArmeEnregistree}
                    nameBtnSuivant="valider"
                    labelBtnSuivant="Valider"
                    labelBtnPrecedent="Revenir à l'étape précédente"
                    actionPrecedente={etapePrecedente}
                    btnSuivantDisabled={false}
                />
            </form>
        </>
    );
};

InformationsIncorrectesEtape3.propTypes = {
    etapePrecedente: PropTypes.func.isRequired,
    tableauConfigHeader: PropTypes.array.isRequired,
    signalerArmeData: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        typeErreur: PropTypes.string.isRequired,
        nouveauNumeroRga: PropTypes.string,
        nouveauNumeroSerie: PropTypes.string,
        isNeutralisee: PropTypes.bool,
        dateNeutralisationArme: PropTypes.string,
        lieuNeutralisationArme: PropTypes.string,
        noNumeroSerie: PropTypes.bool,
    }).isRequired,
};

export default InformationsIncorrectesEtape3;
